import { Col, Row, Skeleton } from 'antd';
import HomeStatCard from '../atoms/HomeStatCard';
import { useTranslation } from 'react-i18next';
import { Profile2User } from 'iconsax-react';
import { useGetBusinessStatisticsQuery } from '../../store/services/business-requests';

const formatStat = (value: number | string | null | undefined): string => {
  if (value == null) return '0';
  return typeof value === 'number' ? String(value) : String(value);
};

const Statistics = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetBusinessStatisticsQuery();

  const payload = data?.payload;
  const statsData = {
    totalRequests: formatStat(payload?.totalRequests),
    approvedRequests: formatStat(payload?.approvedRequests),
    rejectedRequests: formatStat(payload?.rejectedRequests),
    waitingAcceptanceRequests: formatStat(payload?.waitingAcceptanceRequests),
  };

  if (isLoading) {
    return (
      <Row gutter={[16, 16]}>
        {[0, 1, 2, 3].map((key) => (
          <Col span={24} sm={12} md={6} key={key}>
            <div className="flex gap-3 bg-white rounded-xl border border-gray-100 px-4 py-8 shadow-sm">
              <div className="flex items-start pt-1">
                <div className="w-10 h-10 rounded-full bg-gray-100" />
              </div>
              <div className="flex flex-col gap-2 flex-1">
                <Skeleton.Input active size="small" style={{ width: '70%' }} />
                <Skeleton.Input
                  active
                  size="default"
                  style={{ width: '50%' }}
                />
              </div>
            </div>
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} sm={12} md={6}>
        <HomeStatCard
          number={statsData.totalRequests}
          title={t('home.totalRequests')}
          icon={<Profile2User size={20} color="#22C55E" variant="Outline" />}
        />
      </Col>
      <Col span={24} sm={12} md={6}>
        <HomeStatCard
          number={statsData.waitingAcceptanceRequests}
          title={t('home.pendingRequests')}
          icon={<Profile2User size={20} color="#22C55E" variant="Outline" />}
        />
      </Col>
      <Col span={24} sm={12} md={6}>
        <HomeStatCard
          number={statsData.approvedRequests}
          title={t('home.approvedRequests')}
          icon={<Profile2User size={20} color="#22C55E" variant="Outline" />}
        />
      </Col>
      <Col span={24} sm={12} md={6}>
        <HomeStatCard
          number={statsData.rejectedRequests}
          title={t('home.rejectedRequests')}
          icon={<Profile2User size={20} color="#22C55E" variant="Outline" />}
        />
      </Col>
    </Row>
  );
};

export default Statistics;
